import type {Schemas} from 'api/dto.generated';

const dto: Schemas.WorkFlattenedDto = {
  work: {
    id: '89495de6-3796-473f-834c-52af773a4d8d',
    created: 1669324671889,
    modified: 1699546895468,
    preferredTitle: ['Historie og filo'],
    languages: ['nno'],
    agents: [
      {
        roles: ['A01'],
        agentId: 'a86c72cd-4498-4ba7-bfd0-69234ae65d23',
        agentType: 'PERSON',
        agentName: {
          id: '1dd45dfc-195d-4f36-9d15-0aa4ed51184d',
          name: 'Tommy',
          surName: 'Moum',
          nameOrder: 0,
        },
        nationalId: '11782',
      },
      {
        roles: ['A01'],
        agentId: '28cbfce6-9a5d-494d-aa15-14c7998e4c39',
        agentType: 'PERSON',
        agentName: {
          id: 'eeb5e6fe-6144-4773-ac7c-983f7e440460',
          name: 'Test',
          surName: 'Ebba',
          nameOrder: 1,
        },
        nationalId: '8077144',
      },
    ],
    dewey: [],
    intellectualLevel: [],
    literatureType: ['13'],
    teachingMaterials: ['6'],
    themes: ['4CN', '4Z-NO-B', 'YPJH', 'YPJL'],
    subjects: [],
    grep: ['ST', 'SAM3042'],
    educationLevel: ['VG2', 'VG3'],
    bibleContent: [],
    generalNote: [],
    seriesRelations: [
      {
        entityId: '4dcafe6a-1ba6-4d69-8170-f91a13141272',
        role: 'PART_OF',
        type: 'EDUCATIONAL_SERIES',
        title: 'Historie og filosofi',
        numberInSeries: undefined,
      },
    ],
    workRelations: [],
    agentRelations: [],
  },
  expressions: [
    {
      id: '60af6ff2-76f3-416e-bab4-24a54b147f77',
      workId: '89495de6-3796-473f-834c-52af773a4d8d',
      created: 1669324671903,
      modified: 1669324671903,
      expressionFormat: 'ILLUSTRATED_TEXT',
      languages: ['nob'],
      content: [],
      agents: [
        {
          roles: ['A12'],
          agentId: '96203b89-ae0f-467b-b040-b1e115f580bc',
          agentType: 'PERSON',
          agentName: {
            id: 'a9185eec-87a9-4bff-ae34-e9e244810f1e',
            name: 'Inger Sandved',
            surName: 'Anfinsen',
            nameOrder: 0,
          },
          nationalId: '10023785',
        },
      ],
    },
    {
      id: 'd911a99d-521f-4aed-b604-eddd42c25768',
      workId: '89495de6-3796-473f-834c-52af773a4d8d',
      created: 1669324671922,
      modified: 1669324671922,
      expressionFormat: 'ILLUSTRATED_TEXT',
      languages: ['nno'],
      content: [],
      agents: [
        {
          roles: ['A12'],
          agentId: '96203b89-ae0f-467b-b040-b1e115f580bc',
          agentType: 'PERSON',
          agentName: {
            id: 'a9185eec-87a9-4bff-ae34-e9e244810f1e',
            name: 'Inger Sandved',
            surName: 'Anfinsen',
            nameOrder: 0,
          },
          nationalId: '10023785',
        },
      ],
    },
    {
      id: 'f209f4b0-ccd7-422b-9805-ac28308af191',
      workId: '89495de6-3796-473f-834c-52af773a4d8d',
      created: 1669329137319,
      modified: 1669329137319,
      expressionFormat: 'ILLUSTRATED_TEXT',
      languages: ['nno'],
      content: [],
      agents: [],
    },
  ],
  manifestations: [
    {
      id: '8d72edb2-0b96-4bcf-b460-bd2cb89a961e',
      expressionId: '60af6ff2-76f3-416e-bab4-24a54b147f77',
      created: 1669324671965,
      modified: 1699546951573,
      status: 'COMPLETED',
      isbn: '9788202276874',
      ean: '9788202276874',
      mainTitle: 'Historie og filosofi 1',
      edition: 1,
      publishedYear: 2008,
      pageCount: '472',
      contentReceivedDate: '2008-05-29',
      productForm: 'BB',
      productFormDetail: [],
      physicalProperties: [
        {
          type: 'PAGES',
          value: '472',
          unit: undefined,
        },
      ],
      bookGroup: '120',
      productGroup: '12010',
      externalSystemInfo: {
        ids: [150096626],
        created: '2008-04-11T10:06:30Z',
        modified: '2023-10-19T09:25:58Z',
      },
      titleInfo: {
        mainTitles: [
          {
            subTitles: [],
            parallelTitles: [],
            value: 'Historie og filosofi 1',
            order: 1,
          },
        ],
        otherTitles: [],
      },
      generalNote: ['Note'],
      editionNote: [''],
      editionType: [],
      seriesRelations: [],
      imprints: [
        {
          agentId: '4489d172-103f-4e5d-b3d5-d081192f98ec',
          agentName: {
            id: 'e6e8eaaf-95d8-4883-a33f-9f57ce62ef5f',
            name: 'Cappelen Damm',
            nameOrder: 0,
          },
        },
      ],
      subTitles: [],
      productOwners: [
        {
          code: '0008',
          name: 'Cappelen Damm AS',
        },
      ],
      marketingData: {
        products: [
          {
            owner: '0008',
            distributor: 'SD',
            status: 'INACTIVE',
            publisherSalesDate: '2008-05-27',
            inSaleDate: '2008-05-27',
            comingDate: undefined,
            measures: [
              {
                type: 'HEIGHT',
                value: '266',
                unit: 'MM',
              },
              {
                type: 'WIDTH',
                value: '197',
                unit: 'MM',
              },
              {
                type: 'THICKNESS',
                value: '28',
                unit: 'MM',
              },
              {
                type: 'WEIGHT',
                value: '1218',
                unit: 'GRAM',
              },
            ],
            descriptions: [
              {
                content:
                  'Historie og filosofi 1 følger læreplanen fra oldtid og myter til nyere tid og kritisk tenkning. Hvert hovedområde i læreplanen er et eget kapittel. Historie og filosofi 1 dekker læreplanens kompetansemål i programfagets del 1:\n\n·         Oldtid og myter\n\n·         Antikken og samtalen\n\n·         Middelalder og kildebruk\n\n·         Renessanse og forklaring\n\n·         Opplysningstid og perspektiver\n\n·         Nyere tid og kritisk tenkning',
                language: 'nob',
                agentId: undefined,
                type: 'PLAINTEXT',
              },
              {
                content:
                  'Historie og filosofi 1 følger læreplanen fra oldtid og myter til nyere tid og kritisk tenkning. Hvert hovedområde i læreplanen er et eget kapittel. Historie og filosofi 1 dekker læreplanens kompetansemål i programfagets del 1:\n·         Oldtid og myter<br>\n·         Antikken og samtalen<br>\n·         Middelalder og kildebruk<br>\n·         Renessanse og forklaring<br>\n·         Opplysningstid og perspektiver<br>\n·         Nyere tid og kritisk tenkning',
                language: 'nob',
                agentId: undefined,
                type: 'HTML',
              },
            ],
            hidden: false,
          },
        ],
      },
    },
    {
      id: 'c45eefa5-a82a-42e2-a0da-c8ffa4dfa2a4',
      expressionId: 'd911a99d-521f-4aed-b604-eddd42c25768',
      created: 1669324672005,
      modified: 1699547837649,
      status: 'COMPLETED',
      isbn: '9788202285883',
      ean: '9788202285883',
      mainTitle: 'Historie og filosofi 1',
      edition: 1,
      publishedYear: 2008,
      pageCount: '472',
      contentReceivedDate: '2008-09-16',
      productForm: 'BB',
      productFormDetail: [],
      physicalProperties: [
        {
          type: 'PAGES',
          value: '472',
          unit: undefined,
        },
      ],
      bookGroup: '120',
      productGroup: '12010',
      externalSystemInfo: {
        ids: [150096658],
        created: '2008-04-11T13:06:29Z',
        modified: '2023-10-19T09:25:58Z',
      },
      titleInfo: {
        mainTitles: [
          {
            subTitles: [],
            parallelTitles: [],
            value: 'Historie og filosofi 1',
            order: 1,
          },
        ],
        otherTitles: [],
      },
      generalNote: [],
      editionNote: [],
      editionType: [],
      seriesRelations: [],
      imprints: [
        {
          agentId: '4489d172-103f-4e5d-b3d5-d081192f98ec',
          agentName: {
            id: 'e6e8eaaf-95d8-4883-a33f-9f57ce62ef5f',
            name: 'Cappelen Damm',
            nameOrder: 0,
          },
        },
      ],
      subTitles: [],
      productOwners: [
        {
          code: '0008',
          name: 'Cappelen Damm AS',
        },
      ],
      marketingData: {
        products: [
          {
            owner: '0008',
            distributor: 'SD',
            status: 'INACTIVE',
            publisherSalesDate: '2008-09-16',
            inSaleDate: '2008-09-16',
            comingDate: undefined,
            measures: [
              {
                type: 'THICKNESS',
                value: '27',
                unit: 'MM',
              },
              {
                type: 'HEIGHT',
                value: '260',
                unit: 'MM',
              },
              {
                type: 'WIDTH',
                value: '190',
                unit: 'MM',
              },
              {
                type: 'WEIGHT',
                value: '1255',
                unit: 'GRAM',
              },
            ],
            descriptions: [
              {
                content:
                  'Historie og filosofi 1 følger læreplanen fra oldtid og myter til nyere tid og kritisk tenkning. Hvert hovedområde i læreplanen er et eget kapittel. Historie og filosofi 1 dekker læreplanens kompetansemål i programfagets del 1:\n\n·         Oldtid og myter\n\n·         Antikken og samtalen\n\n·         Middelalder og kildebruk\n\n·         Renessanse og forklaring\n\n·         Opplysningstid og perspektiver\n\n·         Nyere tid og kritisk tenkning',
                language: 'nob',
                agentId: undefined,
                type: 'PLAINTEXT',
              },
              {
                content:
                  'Historie og filosofi 1 følger læreplanen fra oldtid og myter til nyere tid og kritisk tenkning. Hvert hovedområde i læreplanen er et eget kapittel. Historie og filosofi 1 dekker læreplanens kompetansemål i programfagets del 1:\n·         Oldtid og myter<br>\n·         Antikken og samtalen<br>\n·         Middelalder og kildebruk<br>\n·         Renessanse og forklaring<br>\n·         Opplysningstid og perspektiver<br>\n·         Nyere tid og kritisk tenkning',
                language: 'nob',
                agentId: undefined,
                type: 'HTML',
              },
            ],
            hidden: false,
          },
        ],
      },
    },
    {
      id: '8ce09ee5-f62a-4e18-a913-2c988b9791e7',
      expressionId: 'f209f4b0-ccd7-422b-9805-ac28308af191',
      created: 1669329137367,
      modified: 1699546895471,
      status: 'PRE_CATALOGED',
      isbn: '9788202740658',
      ean: '9788202740658',
      mainTitle: 'Historie og filo',
      edition: 4,
      publishedYear: 2023,
      contentReceivedDate: '2023-06-06',
      productForm: 'BL',
      productFormDetail: [],
      physicalProperties: [],
      bookGroup: '120',
      productGroup: '12010',
      externalSystemInfo: {
        ids: [150440038],
        created: '2022-05-24T17:21:34Z',
        modified: '2023-10-19T09:26:09Z',
      },
      titleInfo: {
        mainTitles: [
          {
            subTitles: [
              {
                parallelTitles: [],
                value: 'lærebok i historie og filosofi',
                order: 1,
              },
            ],
            parallelTitles: [],
            value: 'Historie og filo',
            order: 1,
          },
        ],
        otherTitles: [],
      },
      generalNote: ['Note'],
      editionNote: [''],
      editionType: [],
      seriesRelations: [],
      imprints: [
        {
          agentId: '4489d172-103f-4e5d-b3d5-d081192f98ec',
          agentName: {
            id: 'e6e8eaaf-95d8-4883-a33f-9f57ce62ef5f',
            name: 'Cappelen Damm',
            nameOrder: 0,
          },
        },
      ],
      subTitles: ['lærebok i historie og filosofi'],
      productOwners: [
        {
          code: '0008',
          name: 'Cappelen Damm AS',
        },
      ],
      marketingData: {
        products: [
          {
            owner: '0008',
            distributor: 'SD',
            status: 'ACTIVE',
            publisherSalesDate: '2023-07-06',
            inSaleDate: '2023-07-06',
            comingDate: undefined,
            measures: [
              {
                type: 'HEIGHT',
                value: '265',
                unit: 'MM',
              },
              {
                type: 'WEIGHT',
                value: '986',
                unit: 'GRAM',
              },
              {
                type: 'THICKNESS',
                value: '23',
                unit: 'MM',
              },
              {
                type: 'WIDTH',
                value: '195',
                unit: 'MM',
              },
            ],
            descriptions: [
              {
                content:
                  'Historie og filosofi 1 (LK20) følger den nye læreplan til fagfornyelsen. Læreboka åpner med et praktisk verktøy der elevene lærer å analysere tekstutdragene i form av modeller for kildekritikk og lesning av filosofiske tekster.\n\nModellene gir elevene et verktøy for selv å utforske filosofiske og historiske spørsmål. Sentrale metoder og begreper i historiefaget og filosofifaget flettes også sammen med fagstoffet i hvert kapittel. Stoffet er i hovedsak presentert kronologisk, men det er også tematiske linjer som følges gjennom boka.\n\nHistorie og filosofi 1 er delt inn i seks hovedkapitler:\n\n1. Mennesket, myter og fortellinger\n\n2. Antikken\n\n3. Middelalderen\n\n4. Renessansen\n\n5. Opplysningstid - modernitetens fødsel\n\n6. To store fortellinger om mening, identitet og motivasjon\n\nHistorie og filosofi stimulerer elevene til undring og refleksjon, og på nettstedet får elevene anledning til å gå i dybden på relevante filosofiske og historiske spørsmål. Historie og filosofi 1 introduserer elevene for fortidens mennesker og tenkning og fremmer spørsmål som er relevant i vår egen samtid. Elevene bringes tett på fortiden gjennom et rikt utvalg av kildetekstutdrag underveis i hvert kapittel med spørsmål i tråd med fagets kjerneelementer, tverrfaglige temaer og kompetansemål.\n\nOppgavestoffet i Historie og filosofi 1 består i hovedsak av utvidende oppgaver som inviterer til utforsking og refleksjon. Oppgavene tar ofte utgangspunkt i kjerneelementer og tverrfaglige temaer.\n\nTil læreverket følger digitale ressurser til elev og lærer med læringsstier og oppgaver for videre fordypning, utforsking og aktualisering av faget. Med lisens får lærer støtte til undervisningen som forslag til årsplaner og vurdering. Nettstedet for elever har gratis innhold til hvert kapittel.\n\nLæreboka finnes også i digtal utgave.',
                language: 'nob',
                agentId: undefined,
                type: 'PLAINTEXT',
              },
              {
                content:
                  '<strong>Historie og filosofi 1</strong> (LK20) følger den nye læreplan til fagfornyelsen. Læreboka åpner med et praktisk verktøy der elevene lærer å analysere tekstutdragene i form av modeller for kildekritikk og lesning av filosofiske tekster.Modellene gir elevene et verkt&oslash;y for selv &aring; utforske filosofiske og historiske sp&oslash;rsm&aring;l. Sentrale metoder og begreper i historiefaget og filosofifaget flettes ogs&aring; sammen med fagstoffet i hvert kapittel. Stoffet er i hovedsak presentert kronologisk, men det er ogs&aring; tematiske linjer som f&oslash;lges gjennom boka.\n<strong>Historie og filosofi 1</strong> er delt inn i seks hovedkapitler:<br>\n1. Mennesket, myter og fortellinger<br>\n2. Antikken<br>\n3. Middelalderen<br>\n4. Renessansen<br>\n5. Opplysningstid &ndash; modernitetens f&oslash;dsel<br>\n6. To store fortellinger om mening, identitet og motivasjon\n<strong>Historie og filosofi</strong> stimulerer elevene til undring og refleksjon, og p&aring; nettstedet f&aring;r elevene anledning til &aring; g&aring; i dybden p&aring; relevante filosofiske og historiske sp&oslash;rsm&aring;l. <strong>Historie og filosofi 1</strong> introduserer elevene for fortidens mennesker og tenkning og fremmer sp&oslash;rsm&aring;l som er relevant i v&aring;r egen samtid. Elevene bringes tett p&aring; fortiden gjennom et rikt utvalg av kildetekstutdrag underveis i hvert kapittel med sp&oslash;rsm&aring;l i tr&aring;d med fagets kjerneelementer, tverrfaglige temaer og kompetansem&aring;l.\nOppgavestoffet i <strong>Historie og filosofi 1</strong> best&aring;r i hovedsak av utvidende oppgaver som inviterer til utforsking og refleksjon. Oppgavene tar ofte utgangspunkt i kjerneelementer og tverrfaglige temaer.\nTil l&aelig;reverket f&oslash;lger digitale ressurser til elev og l&aelig;rer med l&aelig;ringsstier og oppgaver for videre fordypning, utforsking og aktualisering av faget. Med lisens f&aring;r l&aelig;rer st&oslash;tte til undervisningen som forslag til &aring;rsplaner og vurdering. Nettstedet for elever har gratis innhold til hvert kapittel.\nL&aelig;reboka finnes ogs&aring; i digtal utgave. ',
                language: 'nob',
                agentId: undefined,
                type: 'HTML',
              },
            ],
            hidden: false,
          },
        ],
      },
    },
  ],
};

export default dto;
